<template>
  <div :class="[_isMobile() ? 'mobile' : '']">
    <div class="homeIcon" ><i class="iconfont" @click="$router.push({path:'/'})">&#xe751;</i></div>
    <div
      class="login_backgroun"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
    >
      <a-row type="flex" justify="center" align="middle" style="height: 100%;">
        <a-col :xs="22" :sm="18" :md="18" :lg="12" :xl="8" :xxl="6">
          <div class="login_content">
            <div class="login_right login_box">
              <p class="title">登录系统</p>
              <Login />
            </div>
          </div>
        </a-col>
      </a-row>
      
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
// import Login from "../components/user/Login";
import Login from "@/components/user/Login";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],
  components: {
    Login,
  },
  data() {
    return {
      backgroundImage: Vue.ls.get(TENANT_CONFIG).loginBg,
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.homeIcon{
  position: fixed;
  top: 20px;
  left:20px;
  z-index: 99;
  cursor: pointer;
  .iconfont{
    font-size: 24px;
  }
}
.mobile {
  .login-wrap {
    padding: 0 !important;
  }
}
.login-wrap {
  padding: 40px 40px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000039;
}

.login_backgroun{
  width: 100%;
  height: 100vh;
  // background-image: url('../assets/login_backgroun.png');
  background-size: 100% 100%;
  position: relative;
  .login_content{
    width: 100%;
    // height: 400px;
    .login_box{
      width: 100%;
      height: 100%;
      margin: 0 auto;
      // float: left;
      .title{
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin-bottom: 15px;
      }
    }
    .login_left{
      background: #ffffff21;
    }
    .login_right{
      background: #fff;
      border-radius: 20px;
      padding: 20px;
      box-sizing: border-box;
    }
  }
}
</style>